import { clone } from 'ramda';

import { type IJsonQueryUnderground } from '@/packages/api-models/common/json_query';

import { type TJsonQuery } from '../../types';

export function getUndergoundStationIdsFromJsonQuery(jsonQuery: TJsonQuery): number[] {
  const geo = (jsonQuery.geo && clone(jsonQuery.geo.value)) || [];

  return geo.filter(item => item.type === 'underground').map((item: IJsonQueryUnderground) => item.id);
}
